<template>
  <div style="text-align: center;" :style="{ margin: margin }">
    <a
      :href="href"
      target="_blank"
      style="display: inline-block; padding: 8px 22px; min-width: 110px; vertical-align: middle; text-align: center; text-decoration: none; line-height: 1.5; font-size: 16px; font-weight: 600;"
      :style="{
        backgroundColor: bgColor,
        color: color,
        borderRadius,
      }"
      :download="isDownloadHref"
    >
      {{ label.toUpperCase() }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'UiButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    isDownloadHref: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    bgColor: {
      type: String,
      default: '#f7c325',
    },
    borderRadius: {
      type: String,
      default: '32px',
    },
    margin: {
      type: String,
      default: '16px',
    },
  },
}
</script>
